import script from "./CreditBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditBalance.vue?vue&type=script&setup=true&lang=js"

import "./CreditBalance.vue?vue&type=style&index=0&id=d97fb53e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d97fb53e"]])

export default __exports__